<template>
  <div></div>
</template>

<script>
export default {
  name: "ArticleEditor",
};
</script>
